import { CommonTaskStatus } from '@euler/model/enum';
import { ReportShareViewSummary } from '@euler/model/ReportShareViewSummary';
import { TaskListItem } from '@euler/model/TaskListItem';
import { memo, ReactNode } from 'react';
import { View } from 'react-native';
import { kStepKeys, kStepLabels } from '../constants';
import { StepStatus } from '../types';
import { ProgressConnector } from './ProgressConnector';
import { ReportProgressStep } from './ReportProgressStep';

export const ReportProgressRow = memo(
  ({
    item,
    summary,
    loading,
    timedOut,
    historyMode,
  }: {
    item: TaskListItem;
    summary: ReportShareViewSummary | null;
    loading: boolean;
    timedOut?: boolean;
    historyMode?: boolean;
  }) => {
    const stepStatuses: Record<(typeof kStepKeys)[number], StepStatus> = {
      preInspection: item.preInspectionStatus,
      inspection: item.inspectionStatus,
      construction: item.constructionStatus,
      deliveryCheck: item.deliveryCheckStatus,
    };

    const nodes: ReactNode[] = [];
    kStepKeys.forEach((key, idx) => {
      const status = stepStatuses[key];
      nodes.push(
        <ReportProgressStep
          key={key}
          label={kStepLabels[key]}
          status={status}
          viewed={summary?.viewSummary?.[key] ?? null}
          loading={loading}
          timedOut={timedOut}
          historyMode={historyMode}
        />,
      );
      if (idx < kStepKeys.length - 1) {
        nodes.push(
          <ProgressConnector
            key={`c-${key}`}
            active={status === CommonTaskStatus.Finished}
            timedOut={timedOut}
          />,
        );
      }
    });
    return (
      <View
        css={`
          flex-direction: row;
          align-items: flex-start;
        `}
      >
        {nodes}
      </View>
    );
  },
);
